<div class="retailer-commission-container px-2">
<div class="section-menu-items">
    <button
      mat-flat-button
      class="item-each"
      [routerLink]="['create']"
      routerLinkActive="router-link-active"
    >
    <span translate class="translate"> pages.newRetailer.createPricelist</span
      ><mat-icon class="ms-2">add_box</mat-icon>
    </button>
    <button
      mat-flat-button
      class="item-each"
      [routerLink]="['bulkupdate']"
      routerLinkActive="router-link-active"
    >
    <span translate class="translate"> pages.newRetailer.bulkUpdatePricelist</span
      ><mat-icon class="ms-2">edit</mat-icon>
    </button>
    <!--<button
      mat-flat-button
      class="item-each"
    >
    <span translate class="translate"> Export pricelist</span
      ><i class="mi mi-save-alt ms-2"></i>
    </button> -->
    <button
    mat-flat-button
    class="item-each"
    [routerLink]="['import']"
    routerLinkActive="router-link-active"
    >
    <span translate class="translate"> pages.newRetailer.importPricelist</span
      ><i class="mi mi-save-alt ms-2"></i>
    </button>    
  </div>
  <router-outlet></router-outlet>
</div>
